import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import * as fromStore from "../store";
import {filter, first, switchMap} from "rxjs/operators";
import {Store} from "@ngrx/store";
import {Config} from "../config/config";
import {Product} from "../websites/website/product";
import {SortByPipe} from "../shared/pipes/sort-by.pipe";

@Injectable()
export class AvailablePluginsResolver implements Resolve<any|null> {


  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _sortPipe: SortByPipe,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      this._store.select(fromStore.getTenWebProductsLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => this._store.select(fromStore.getTenWebProducts)),
          first()
        )
        .subscribe((products) => {
          resolve(this._filter10WebPlugins(products));
        });
    });
  }

  private _filter10WebPlugins(plugins: Product[]): Product[] | null {
    if (!plugins || !plugins.length) {
      return null;
    }

    // Filter plugins with paid version
    plugins = plugins.filter(plugin => !!plugin.paidVersionAvailable);

    // Sort all by popularRank (or your default logic)
    const sortedProducts: Product[] = <Product[]>this._sortPipe.transform(plugins, 'popularRank', 'asc');

    // Separate parents and addons
    const parents: Product[] = [];
    const addonsMap: { [key: number]: Product[] } = {};

    for (const plugin of sortedProducts) {
      if ([Config.optimizerPluginSlug, Config.aiAssistantPluginSlug, 'ai-assistant-by-10web-seo-pack'].includes(plugin.slug)) {
        continue; // Skip excluded slugs
      }

      // Trim description
      if (plugin.description.length > 60) {
        const shortDesc = plugin.description.substr(0, 60);
        plugin.description = shortDesc.substr(0, Math.min(shortDesc.length, shortDesc.lastIndexOf(" "))) + '...';
      }

      // Categorize
      if (plugin.parentId === 0) {
        parents.push(plugin);
      } else {
        if (!addonsMap[plugin.parentId]) {
          addonsMap[plugin.parentId] = [];
        }
        addonsMap[plugin.parentId].push(plugin);
      }
    }

    // Sort parent plugins, then append their addons
    const result: Product[] = [];
    for (const parent of parents) {
      result.push(parent);
      if (addonsMap[parent.productId]) {
        result.push(...addonsMap[parent.productId]);
      }
    }

    return result;
  }

}
